import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { DialogContentWithCards } from '../components/DialogContent';
import { DialogTitle } from '../components/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import SelectableTable from '../components/SelectableTable';
import { TextInput } from '../components/TextInput';
import { Chips } from '../components/Chips';
import SimpleTable from '../components/SimpleTable';
import { PaperCard } from '../components/PaperCard';
import { SelectInput } from '../components/SelectInput';
import SelectOrganization from '../containers/SelectOrganization';
import MaterialTable from 'material-table';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import Checkbox from '@material-ui/core/Checkbox';
import VisibilityOnIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import Tooltip from '@material-ui/core/Tooltip';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import _ from 'lodash';
import MultiInputTextField from '../components/MultiInputTextField';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { languageOptions, timeZoneOptions } from '../utils/deviceGroupOptions';
import MenuItem from '@material-ui/core/MenuItem';

export const EditDeviceGroupDialog = ({
    onClose,
    onSave,
    deviceGroup,
    allAppBundles,
    selectedBundleKeys,
    onBundleSelect,
    allApps: { managedApps, externalApps },
    selectedApps,
    appsApprovedByBundles,
    onAppSelect,
    name,
    registrationCode,
    nameNotUnique,
    registrationCodeNotUnique,
    saveAvaliable,
    onNameChange,
    onRegistrationCodeChange,
    devices,
    apps,
    kioskAppKey,
    kioskAppOptions,
    onKioskAppChange,
    organizationKey,
    onOrganizationChange,
    hiddenApps,
    onAppHide,
    onFTUFilePathsChange,
    firstTimeUseFilePaths,
    onFirstTimeUseAppChange,
    onLocaleChange,
    onTargetPUIVersionChange,
    onTimeZoneChange,
    firstTimeUseAppKey,
    deviceSystemVesions,
    localeLanguageTag,
    timeZoneSetting,
    targetDeviceSystemVersions,
}) => {
    const skinnyTableHeader = {
        paddingRight: '0px',
        width: '1px',
    };

    let getAppSelectionValid = (appKey) => {
        return appKey in appsApprovedByBundles || appKey in selectedApps || appKey === 'NONE';
    };

    let getTableData = () => {
        let data = Object.values(apps);
        data = _.groupBy(data, (app) => {
            return app.packageName + app.organizationRef.id; // group by packageName and org
        });
        data = _.map(Object.values(data), (appVersions) => {
            appVersions = _.orderBy(appVersions, ['versionCode', 'versionName'], ['desc', 'desc']);
            let primaryApp = null;
            let defaultVersionClone = null;
            for (let i = 0; i < appVersions.length; i++) {
                let appVersion = appVersions[i];
                if (appVersion.defaultVersionClone) {
                    defaultVersionClone = appVersion;
                    if (!primaryApp) primaryApp = appVersion;
                }
                if (selectedApps[appVersion._id]) primaryApp = appVersion;
            }
            if (!primaryApp) primaryApp = appVersions[0];
            if (!primaryApp.tableData) primaryApp.tableData = {};
            primaryApp.tableData.appVersions = appVersions;
            primaryApp.tableData.defaultVersionClone = defaultVersionClone;
            return primaryApp;
        });
        return data;
    };

    let columns = [
        {
            title: 'Approved',
            headerStyle: skinnyTableHeader,
            render: (rowData) => {
                let checked = rowData._id in selectedApps || rowData._id in appsApprovedByBundles;
                let title = checked ? 'App Approved' : 'App Not Approved';
                return (
                    <Tooltip title={title} aria-label={title}>
                        <Checkbox checked={checked} onChange={(event) => onAppSelect({ key: rowData._id, value: event.target.checked })} />
                    </Tooltip>
                );
            },
            customSort: (rowDataA, rowDataB) => {
                let selectedA = rowDataA._id in selectedApps;
                let selectedB = rowDataB._id in selectedApps;
                return selectedA === selectedB ? 0 : selectedA ? -1 : 1;
            },
        },
        {
            title: '',
            sorting: false,
            headerStyle: skinnyTableHeader,
            cellStyle: { padding: '0px' },
            render: (rowData) => {
                let disabled = !(rowData._id in selectedApps) && !(rowData._id in appsApprovedByBundles);
                let checked = rowData._id in hiddenApps || !apps[rowData._id].showInLaunchers;
                let title = checked ? 'Hide App in Mighty Launcher' : 'Show App in Mighty Launcher';
                return (
                    <Tooltip title={title} aria-label={title}>
                        <Checkbox
                            checked={checked}
                            disabled={disabled || !apps[rowData._id].showInLaunchers}
                            style={disabled ? { display: 'none' } : {}}
                            onChange={(event) => onAppHide({ key: rowData._id, value: event.target.checked })}
                            icon={<VisibilityOnIcon />}
                            checkedIcon={<VisibilityOffIcon />}
                        />
                    </Tooltip>
                );
            },
        },
        {
            title: 'Version',
            render: (rowData) => {
                if (!rowData.apkUrl) return '';
                return (
                    <FormControl style={{ width: '100%' }}>
                        <NativeSelect
                            value={rowData._id}
                            onChange={(event) => {
                                if (event.target.value !== rowData._id) {
                                    onAppSelect({ key: rowData._id, value: false });
                                    if (kioskAppKey === rowData._id) {
                                        onKioskAppChange(event.target.value);
                                    }
                                }
                                onAppSelect({ key: event.target.value, value: true });
                            }}
                            inputProps={{
                                id: 'version-native-helper',
                            }}
                        >
                            {rowData.tableData.defaultVersionClone ? <option value={rowData.tableData.defaultVersionClone._id}>Default</option> : ''}
                            {rowData.tableData.appVersions.map((appVersion) => {
                                if (appVersion.defaultVersionClone) return '';
                                return (
                                    <option key={appVersion._id} value={appVersion._id}>
                                        {appVersion.latestVersion}
                                        {appVersion.versionName ? ` (${appVersion.versionName})` : ''}
                                        {appVersion.defaultVersion ? ` [Current Default]` : ''}
                                    </option>
                                );
                            })}
                        </NativeSelect>
                    </FormControl>
                );
            },
        },
        {
            title: 'Icon',
            sorting: false,
            render: (rowData) => <img src={rowData.iconUrl} alt={rowData.title} style={{ width: '50px' }} />,
        },
        {
            title: 'Title',
            field: 'title',
        },
        {
            title: 'Package Name',
            field: 'packageName',
        },
        {
            title: 'App Type',
            defaultSort: 'desc',
            render: (rowData) => (rowData.apkUrl ? 'Managed' : 'External'),
            customSort: (rowDataA, rowDataB) => {
                let typeA = rowDataA.apkUrl ? 'Managed' : 'External';
                let typeB = rowDataB.apkUrl ? 'Managed' : 'External';
                return typeA.localeCompare(typeB);
            },
        },
        {
            title: 'Version Code',
            field: 'latestVersion',
        },
        {
            title: 'Version Name',
            field: 'versionName',
        },
    ];

    //   console.log(deviceSystemVesions);
    return (
        <Dialog maxWidth="lg" scroll="body" onClose={onClose} open>
            <DialogTitle onCancel={onClose} onSave={onSave} saveAvaliable={saveAvaliable && getAppSelectionValid(kioskAppKey) && getAppSelectionValid(firstTimeUseAppKey)} darkBg>
                Device Group: {deviceGroup.name}
            </DialogTitle>
            <DialogContentWithCards>
                <Typography variant="caption">* Required Inputs</Typography>

                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <PaperCard>
                            <TextInput label={nameNotUnique ? 'Must be unique' : 'Name'} value={name} error={nameNotUnique} onChange={onNameChange} required />
                            <TextInput
                                label={registrationCodeNotUnique ? 'Must be unique' : 'Registration Code'}
                                value={registrationCode}
                                error={registrationCodeNotUnique}
                                onChange={onRegistrationCodeChange}
                                required
                            />

                            <Chips data={allAppBundles} onChange={onBundleSelect} selectedValue={selectedBundleKeys} title="Approved App Bundles" />

                            <SelectInput
                                value={kioskAppKey}
                                options={kioskAppOptions}
                                onChange={onKioskAppChange}
                                label={getAppSelectionValid(kioskAppKey) ? 'Kiosk App' : 'Not a valid Kiosk App selection'}
                                error={!getAppSelectionValid(kioskAppKey)}
                            />

                            <SelectOrganization value={organizationKey} onChange={onOrganizationChange} />
                        </PaperCard>
                    </Grid>

                    <Grid container item spacing={3} xs={6} alignContent="flex-start">
                        <Grid item xs={12}>
                            <PaperCard>
                                <Typography variant="body1">There are two ways to add new devices to this group:</Typography>
                                <Typography variant="body2" component="span">
                                    <ol>
                                        <li>Register a new device using the Registration Code.</li>
                                        <li>Move an existing device to this group from the Devices page.</li>
                                    </ol>
                                </Typography>
                            </PaperCard>
                        </Grid>
                        <Grid item xs={12}>
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>First Time Use Settings (Advanced)</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div style={{ width: '100%' }}>
                                        <SelectInput
                                            value={firstTimeUseAppKey}
                                            options={kioskAppOptions}
                                            onChange={onFirstTimeUseAppChange}
                                            label={getAppSelectionValid(firstTimeUseAppKey) ? 'First Time Use App' : 'Not a valid First Time Use App selection'}
                                            error={!getAppSelectionValid(firstTimeUseAppKey)}
                                        />
                                        <MultiInputTextField initData={firstTimeUseFilePaths} onDataChange={onFTUFilePathsChange} />
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>Pico Settings (Advanced)</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div style={{ width: '100%' }}>
                                        {/* <FormControl style={{ width: "100%", marginTop: '16px', marginBottom: '8px' }} variant="outlined">
                      <InputLabel id="select-label">System PUI/Controller Version</InputLabel>
                      <Select
                        onChange={event => onTargetPUIVersionChange(event.target.value)}
                        id="select"
                        label="System PUI/Controller Version"
                      >
                        <MenuItem key="UNMANAGED" value="UNMANAGED">
                          Unmanaged
                        </MenuItem>
                        {deviceSystemVesions.map(option => (
                          <MenuItem key={option._id} value={option._id}>
                            {option._id}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl> */}
                                        <FormControl style={{ width: '100%', marginTop: '16px', marginBottom: '8px' }} variant="outlined">
                                            <InputLabel id="select-label">System Language</InputLabel>
                                            <Select value={localeLanguageTag} onChange={(event) => onLocaleChange(event.target.value)} id="select" label="System Language">
                                                <MenuItem id="UNMANAGED" value="UNMANAGED">
                                                    Unmanaged
                                                </MenuItem>
                                                {languageOptions.map((option) => (
                                                    <MenuItem key={`${option.language}-${option.country}`} value={`${option.language}-${option.country}`}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl style={{ width: '100%', marginTop: '16px', marginBottom: '8px' }} variant="outlined">
                                            <InputLabel id="select-label">System Time Zone</InputLabel>
                                            <Select value={timeZoneSetting} onChange={(event) => onTimeZoneChange(event.target.value)} id="select" label="System Time Zone">
                                                <MenuItem key="UNMANAGED" value="UNMANAGED">
                                                    Unmanaged
                                                </MenuItem>
                                                <MenuItem key="AUTO" value="AUTO">
                                                    Auto (Based on Location)
                                                </MenuItem>
                                                {timeZoneOptions.map((option) => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        GMT{option.offset < 0 ? '' : '+'}
                                                        {option.offset} {option.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <MaterialTable
                            key={'default'}
                            title="Approved Apps"
                            columns={columns}
                            data={getTableData()}
                            icons={{
                                SortArrow: ArrowUpwardIcon,
                            }}
                            options={{
                                sorting: true,
                                pageSize: 25,
                                pageSizeOptions: [5, 10, 25, 100],
                                padding: 'dense',
                                actionsColumnIndex: -1,
                                debounceInterval: 500,
                                toolbarButtonAlignment: 'right',
                                draggable: false,
                                emptyRowsWhenPaging: false,
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContentWithCards>
        </Dialog>
    );
};
